import { render, staticRenderFns } from "./FamilyCategories.vue?vue&type=template&id=c511d172&"
import script from "./FamilyCategories.vue?vue&type=script&lang=js&"
export * from "./FamilyCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports